import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import numeral from 'numeral';
import moment from 'moment';
import { DateRange, getDateRange } from '../../../components/DateRange';

import BlankState from '../../../components/BlankState';
import DataTable from '../../../components/DataTable';
import Page from '../../../components/Page';

import { fetchFilteredPolicies } from '../../../actions/policies';
import { listInsurers } from '../../../actions/insurers';
import { listBrokers } from '../../../actions/brokers';

import { getFilteredPolicies } from './../../../utils/apiService';

class Policies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: {
        insurer: '',
        intermediary: '',
        start_date: '',
        end_date: '',
        report: false
      }
    };
    this.baseState = this.state;
  }

  componentDidMount() {
    const { listInsurers, listBrokers } = this.props;

    listInsurers();
    listBrokers();

    this.getPolicies();
  }

  getPolicies() {
    const { fetchFilteredPolicies } = this.props;

    fetchFilteredPolicies(this.state.filter);
  }

  onChange = e => {
    const { name, value } = e.target;
    this.setState({
      filter: {
        ...this.state.filter,
        [name]: value
      }
    });
  };
  handleSubmission = e => {
    e.preventDefault();
    this.getPolicies(this.state.filter);
  };
  handleReset() {
    window.location.reload();
  }

  onChangeDateRange = e => {
    let range = getDateRange(e.target.value);
    if (range.hasOwnProperty('start_date')) {
      this.setState({
        date_range: range,
        filter: {
          insurer: this.state.insurer,
          start_date: range.start_date,
          end_date: range.end_date
        }
      });
    }
  };

  render() {
    const { policies, brokers, insurers } = this.props;
    return (
      <Page isAdminPage={true} pageTitle="Policies">
        <div className="card">
          <form
            className="form-inline filter-form ng-pristine ng-valid"
            onSubmit={this.handleSubmission}
          >
            <div className="form-group">
              {!!JSON.parse(sessionStorage.user).insurer ? null : (
                <select
                  className="form-control"
                  name="insurer"
                  onChange={this.onChange}
                >
                  <option value="">All Insurers</option>
                  {insurers.insurers.map((insurer, index) => {
                    return (
                      <option key={index} value={insurer.id}>
                        {insurer.company_name}
                      </option>
                    );
                  })}
                </select>
              )}
            </div>
            &nbsp;
            <div className="form-group">
              {brokers.brokers.length > 0 ? (
                <select
                  className="form-control"
                  name="intermediary"
                  onChange={this.onChange}
                >
                  <option value="">All Brokers</option>
                  {brokers.brokers.map((broker, index) => {
                    return (
                      <option key={index} value={broker.id}>
                        {broker.name}
                      </option>
                    );
                  })}
                </select>
              ) : null}
            </div>
            &nbsp;
            <div className="form-group">
              <DateRange
                name="date_range"
                className="form-control"
                onChange={this.onChangeDateRange}
              />
            </div>
            &nbsp;
            <div className="form-group">
              <button className="btn btn-success">
                <i className="icon ion-funnel" /> Filter
              </button>
            </div>
          </form>
          <br />
          <br />
          <br />
          {policies.filteredPolicies.length > 0 ? (
            <DataTable
              tableId="policies-table"
              columnTitles={[
                'Created By',
                'Policy No.',
                'Policy Holder',
                'Insurer',
                'Intermediary',
                'Status',
                'Premium (TZS.)',
                'Sum Insured (TZS.)',
                'Paid',
                'Customs Verified',
                'Created On',
                'Expires'
              ]}
            >
              {policies.filteredPolicies.map((policy, index) => {
                return (
                  <tr key={policy.id}>
                    <td>{policy.creator_name}</td>
                    <td>{policy.policy_number || '-'}</td>
                    <td>{policy.proposer_name || '-'}</td>
                    <td>{policy.insurer_name}</td>
                    <td>{policy.intermediary_name || '-'}</td>
                    <td>{policy.policy_status}</td>
                    <td>{numeral(policy.premium).format('0,0.00')}</td>
                    <td>
                      {numeral(policy.total_sum_insured).format('0,0.00')}
                    </td>
                    <td>
                      {policy.is_paid ? (
                        <span className="label label-success">Yes</span>
                      ) : (
                        <span className="label label-danger">No</span>
                      )}
                    </td>
                    <td>
                      {policy.is_verified === true ? (
                        <span className="label label-success">Verified</span>
                      ) : (
                        <span className="label label-warning">
                          Not Verified
                        </span>
                      )}
                    </td>
                    <td>{moment(policy.start_date).format('MMM Do, YYYY')} </td>
                    <td>
                      {moment(policy.cover_end_date).format('MMM Do, YYYY')}{' '}
                    </td>
                  </tr>
                );
              })}
            </DataTable>
          ) : (
            <BlankState
              data={policies.filteredPolicies}
              dataName="Policies"
              isDataLoading={policies.policies_loading}
            />
          )}
        </div>
      </Page>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  policies: state.policies,
  insurers: state.insurers,
  brokers: state.brokers
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { fetchFilteredPolicies, listInsurers, listBrokers },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Policies);



// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/Policies.jsx